/**
 * Universal Quoter Tab Constants
 * Defines the available tabs in the Universal Quoter widget
 */

const QUOTER_TABS = {
  ANNUITY: 'new-annuity',
  LIFE: 'new-life',
  LTC: 'new-ltc'
};

// Allowed tabs for validation
const ALLOWED_QUOTER_TABS = [QUOTER_TABS.ANNUITY, QUOTER_TABS.LIFE];

module.exports = {
  QUOTER_TABS,
  ALLOWED_QUOTER_TABS
};
